(function () {
    "use strict";
    $(document).ready(function () {
        // To set email address of the user for okta
        $("#btn-okta-close").hide();
        var user_name = '';
        //////////////////////////////////////////////////////////////////////////////////////
        //Login
        //////////////////////////////////////////////////////////////////////////////////////
        $('.btnLogin').click("#loginModal", function () {

            checkIsMigratedAndShowmodal();
        });
        function getCookie(cookiename) {
            var parts = document.cookie.split(cookiename + "=");
            if (parts.length == 2)
                return parts.pop().split(";").shift();
        }


        $("#MenuLogin").click(function (e) {
            e.preventDefault();
            checkIsMigratedAndShowmodal();
        });

        function checkIsMigratedAndShowmodal() {
            var checkMigratedEmail = getCookie('UserEmail');
            if (checkMigratedEmail != '' && checkMigratedEmail != undefined && checkMigratedEmail != null) {
                $("#loginModal").modal("hide");
                $("#oktaWidgetModal").modal('show');



                //$("#btn-okta-close").show();
                //HideForgetpasswordlinkforIdp();
                user_name = decodeURIComponent(checkMigratedEmail);
                setTimeout(fillUsername, 500);
            } else {
                $("#loginModal").modal();
            }
            $("#btn-okta-close").show();
        }

        $("#Frmresetpassword").submit(function (e) {
            e.preventDefault();
            var validation2 = new mclValidation("Frmresetpassword");
            if (validation2.ajaxCheck()) { //ajax validation                
                $.ajax({
                    type: "POST",
                    url: base_url + "home/resetpassword/" + $("#UserPM_Username").val(),
                }).done(function () {
                    $("#Emailsuccessmessage").fadeIn(500);
                    SpinnerStop();
                }).fail(function () {
                    $("#Emailsuccessmessage").fadeIn(500);
                    SpinnerStop();
                })
            }
        });

        //////Okta Integration
        $('#validate-user').click(function (e) {
            var loginForm = $('#loginForm');

            if (ValidateFormFields()) {
                var token = $('input[name="__RequestVerificationToken"]', loginForm).val();
                e.preventDefault();
                SpinnerSpin();
                $.ajax({
                    type: "POST",
                    url: "/home/isusermigrated",
                    content: "application/json; charset=utf-8",
                    dataType: "json",
                    data: { __RequestVerificationToken: token, userName: $('#txtUsername').val().trim() },
                }).done(function (data) {
                    if ((data.username == null && data.username == undefined)) {
                        $(".UserNameMsg").html("User does not exist.");
                        SpinnerStop();
                        return;
                    }
                    if (data.isMigrated) {
                        user_name = data.email;
                        $("#loginModal").modal("hide");
                        $("#oktaWidgetModal").modal('show');
                        setTimeout(fillUsername, 500);
                        $('body').css('overflow', 'hidden');
                        SpinnerStop();
                    }
                    else if (!data.isMigrated && data.userMigrationMessage != null && data.userMigrationMessage != '') {
                        $("#loginModal").modal("hide");
                        $("#userMigratedModal").modal("show");
                        $("#validate-user").hide();
                        $(".migratedMsg").html(data.userMigrationMessage);
                        $("#btn-okta-close").hide();
                        data.userMigrationMessage = '';
                        SpinnerStop();
                    }
                    else {
                        $("#userMigrated").modal("hide");
                        $("#divPassword").show();
                        $('#lblUsername').text("Username");
                        $('#txtUsername').val("");
                        $("#validate-user").hide();
                        $("#btn-okta-close").hide();
                        $("#btn-login").show();
                        $('#validate-user').removeAttr("type").attr("type", "button");
                        $('#btn-login').removeAttr("type").attr("type", "submit");

                        SpinnerStop();
                    }
                }).fail(function () {
                    window.location.reload(true);
                });
            }
            else {
                return false;
            }
        });

        function ValidateFormFields() {
            var isValid = true;
            var regexEmailexp = new RegExp(/^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/);
            $(loginForm).find(':required').each(function () {
                if ($(this).val().trim() === '') {
                    isValid = false;
                    $(".UserNameMsg").html("Please fill the Email");
                } else {
                    $(".UserNameMsg").html("");
                    if (regexEmailexp.test($(this).val().trim())) {
                        $(".UserNameMsg").html("");
                    }
                    else {
                        isValid = false;
                        $(".UserNameMsg").html("Invalid Email");
                    }
                }
            });
            return isValid;
        };
        // Set the email id as a okta user name in Okta popup screen
        function fillUsername() {
            var element = document.getElementById("idp-discovery-username");
            if (element != null && element != undefined) {
                element.focus();
                document.execCommand('selectAll', false);
                document.execCommand('insertText', false, user_name);
                $("#btn-okta-close").show();
            }
            HideForgetpasswordlinkforIdp();
        }

        $('#btn-close-validation').click(function (e) {
            $("#validationMessageModal").hide();
            $("#validationMessageModal").addClass("fade");
            $(".validationMsg").html("");
        });

        function HideForgetpasswordlinkforIdp() {
            $("#idp-discovery-username").blur(function (event) {
                var IsIdp = isIDPDomain(document.getElementById("idp-discovery-username").value);
                if (IsIdp || document.getElementById("idp-discovery-username").value == '') {
                    $('a.link.js-forgot-password').css({ display: 'none' });
                }
                else {
                    $('a.link.js-forgot-password').css({ display: 'block' });
                }
            });
            $("#idp-discovery-username").focus(function (event) {
                $('#help-links-container').css({ display: 'none' });
            });
        }

        function isIDPDomain(email) {
            var emailDomain = email.split('@')[1];
            if (emailDomain == undefined || emailDomain == '' || emailDomain == null) {
                return true;
            }
            return idpDomainList.includes('@' + emailDomain);
        }
        //////Okta Integration

        var TwoFA = false;
        $("#loginForm").on("submit", function (e) {
            e.preventDefault();
            SpinnerSpin();
            $.ajax({
                type: "POST",
                url: "/home/login",
                data: $(this).serialize()
            }).done(function (data) {
                if (data == "ok") {
                    window.location.reload(true);
                } else if (data == "2fa") {
                    TwoFA = true;
                    $("#loginModal").modal("hide");
                    SpinnerStop();
                }
                else if (data == "redirectUserIfMigrated") {
                    $("#loginModal").modal("hide");
                    $("#validationMessageModal").show();
                    $("#validationMessageModal").removeClass("fade");
                    $(".validationMsg").html(userMigratedMessage);
                    SpinnerStop();
                }
                else {
                    $(".LoginMsg").html("Invalid username / password");
                    SpinnerStop();
                }
            }).fail(function () {
                window.location.reload(true);
            });
        });

        $("#loginModal").on("hidden.bs.modal", function () {
            if (TwoFA) {
                $("#TwoFAModal").modal();
                SpinnerStop();
            }
        });

        $("#TwoFAForm").on("submit", function (e) {
            e.preventDefault();
            SpinnerSpin();
            $.ajax({
                type: "POST",
                url: "/home/twofacheck",
                data: $(this).serialize()
            }).done(function (data) {
                if (data == "ok") {
                    window.location.reload(true);
                } else {
                    $(".TwoFAError").removeClass("NoDisplay");
                    SpinnerStop();
                }
            }).fail(function () {
                window.location.reload(true);
            });
        });
        //////////////////////////////////////////////////////////////////////////////////////








        //var STS = 3;

        //SetSTS();
        //SetSlick();
        //$(window).on("resize", function () {
        //    SetSTS();
        //    SetSlick();
        //});
        //function SetSTS() {
        //    if ($(window).width() > 1000) {

        //        STS = 4;
        //    }
        //    else if ($(window).width() < 1000 && $(window).width() > 600) {

        //        STS = 2;
        //    } else if ($(window).width() < 600) {

        //        STS = 1;
        //    }
        //}
        //function SetSlick() {
        //    if ($(".slick-track").length > 0)
        //        $(".SystemContainer").slick("destroy")
        //    $(".SystemContainer").slick({
        //        rows: 2,
        //        slidesPerRow: STS + 1,
        //        slidesToScroll: STS,
        //        variableWidth: false, // Number of slides to scroll at a time
        //        infinite: false, // Disable infinite loop
        //        dots: false, // Show navigation dots 
        //        prevArrow: '<button class="slick-prev">Previous</button>', // Custom previous arrow
        //        nextArrow: '<button class="slick-next">Next</button>', // Custom next arrow
        //        adaptiveHeight: true
        //    });
        //} 


        $(".portalRequest").on("click", function (e) {
            e.preventDefault();
            $("#requestedPortal").val($(this).data("id")); //set the system ID on the request form 
            var subject = $(this).data("id");
            if ($(this).data("li") == "yes") {
                $.ajax({
                    type: "post",
                    url: base_url + "home/requestaccess",
                    data: { subject: subject }
                }).done(function (data) {
                    if (data == "Unable to process request.") {
                        swal({
                            title: "",
                            text: data,
                            type: "error",
                            showCancelButton: false,
                            confirmButtonColor: "#43ac6a",
                            confirmButtonText: "Ok",
                            closeOnConfirm: true
                        });
                    } else {
                        swal({
                            title: "",
                            text: data,
                            type: "success",
                            showCancelButton: false,
                            confirmButtonColor: "#43ac6a",
                            confirmButtonText: "Ok",
                            closeOnConfirm: true
                        });
                    }
                });
            } else {
                $("#emailModal").modal(); //show modal instead
            }
        });

        $(document).on("submit", "#newUserRequestForm", function (e) {
            e.preventDefault();
            $.ajax({
                type: "post",
                url: base_url + "home/requestaccess",
                data: $(this).serialize()
            }).done(function (data) {
                $("#emailModal").modal('hide');
                setTimeout(function () {
                    if (data == "Unable to process request.") {
                        swal({
                            title: "",
                            text: data,
                            type: "error",
                            showCancelButton: false,
                            confirmButtonColor: "#43ac6a",
                            confirmButtonText: "Ok",
                            closeOnConfirm: true
                        });
                    } else {
                        swal({
                            title: "",
                            text: data,
                            type: "success",
                            showCancelButton: false,
                            confirmButtonColor: "#43ac6a",
                            confirmButtonText: "Ok",
                            closeOnConfirm: true
                        });
                    }
                }, 500);
            });
        });

        ReshuffleCards();
   function ReshuffleCards()
        {
        var container = document.getElementById("SystemContainer");
        var anchorTags = container.querySelectorAll("a");

        // Separate anchor tags with light grey background
        var lightGreyAnchors = [];
        var otherAnchors = [];

        anchorTags.forEach(function (anchor) {
            if (anchor.querySelector(".System").style.backgroundColor === "lightgrey") {
                lightGreyAnchors.push(anchor);
            } else {
                otherAnchors.push(anchor);
            }
        });

        // Clear existing content in the container
        container.innerHTML = "";

        // Append other anchors first
        otherAnchors.forEach(function (anchor) {
            container.appendChild(anchor);
        });

        // Append anchors with light grey background at the end
        lightGreyAnchors.forEach(function (anchor) {
            container.appendChild(anchor);
        });
    }
        // The existing spinner function is not accessable on index due to which we have added here
    }
    );
})();